// based on rc-notification 3.3.1
import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-notification/index.js
// module id = 358
// module chunks = 0